<template>
  <div class="agreement-flow-with-agreement-request-id">
    <Loading v-if="!initialized" />
    <div class="agreement-flow-with-agreement-request-id--inner" v-if="initialized">
      <AgreementFlow
        :AgreementFlowServiceConstructorArgs="AgreementFlowServiceConstructorArgs"
        :shouldPreviewAsPrint="shouldPreviewAsPrint"
      />
    </div>
  </div>
</template>
<script lang="ts">
import { PropType } from 'vue'
import { ModelPsAgreementRequests } from '../../models/fireModels/types'
import AgreementFlow from './AgreementFlow.vue'
import { initAgreementFlowServiceConstructorArgsWithAgreementRequest } from './initAgreementFlowServiceWithAgreementRequest'

const fetchData = async idOrPkey => {
  const shouldFetchWithDefaultModelEndpoint = !!(
    Number(idOrPkey) &&
    $core.$embAuth?.user?.id &&
    $core.$models.ps_agreement_requests
  )
  if (shouldFetchWithDefaultModelEndpoint) {
    return (
      await $core.$models.ps_agreement_requests.find({
        filter: {
          id: {
            _eq: idOrPkey,
          },
        },
        fields: ['*'],
      })
    )?.[0]
  }
  const res = await $core.$d.transport.get(`/public/c/psag/getAgreement?pkey=${idOrPkey}`)
  return res?.data
}

/**
 * 同意リクエストの ID を受け取って、同意リクエストに関連するフローを表示する コンポーネント
 * - 役割としては data の受け渡しのみ
 */
export default {
  name: 'AgreementFlowWithAgreementRequestId',
  components: { AgreementFlow },
  props: {
    AgreementFlowWithAgreementRequestId: {
      type: Number,
      required: true,
    },
    AgreementRequestData: {
      type: Object as PropType<ModelPsAgreementRequests>,
      required: false,
    },
    shouldPreviewAsPrint: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      AgreementRequest: this.AgreementRequestData as ModelPsAgreementRequests,
      initialized: false,
    }
  },
  async mounted() {
    if (!this.AgreementRequestData) {
      if (!this.AgreementFlowWithAgreementRequestId) {
        $core.$toast.errorToast('AgreementFlowWithAgreementRequestId は必須です')
        return
      }
      // const res = await $core.$d.transport.get(`/public/psag/byId/${this.AgreementFlowWithAgreementRequestId}`)
      this.AgreementRequest = (await fetchData(
        this.AgreementFlowWithAgreementRequestId,
      )) as ModelPsAgreementRequests
    } else {
      this.AgreementRequest = this.AgreementRequestData
    }
    this.initialized = true
  },
  computed: {
    AgreementFlowServiceConstructorArgs() {
      return initAgreementFlowServiceConstructorArgsWithAgreementRequest(
        this.AgreementRequest,
      )
    },
  },
}
</script>
